// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"team_mainContainer__18ZhZ","mainParagraph":"team_mainParagraph__2vm30"};